import { motion } from "framer-motion";
import { useGlobalStateContext } from "../context/globalContext";
import { variant02, variantContainer } from "../motion/variants";

const Footer = () => {
  const { hiddenNav } = useGlobalStateContext();

  return (
    <motion.footer
      id="footer"
      variants={variantContainer(1, hiddenNav)}
      initial="hidden"
      animate="visible"
    >
      <motion.div variants={variant02}>Apollo 11</motion.div>
      <motion.div variants={variant02}>Man on the moon</motion.div>
      <motion.div variants={variant02}>The Visual Archive</motion.div>
    </motion.footer>
  );
};

export default Footer;
